module.exports = __webpack_public_path__ + "media/images/icon/icon_night-dd3051a4a36678374570b0667d973431.png";